/**
 * Party
 * iMIS Party API
 *
 * OpenAPI spec version: 20.3.44
 * Contact: support@advsol.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Datacontract represents the unique identifier of an entity.
 */
export class IdentityData { 
    /**
     * The DataType must be \"Asi.Soa.Core.DataContracts.IdentityData, Asi.Contracts\"
     */
  $type = 'Asi.Soa.Core.DataContracts.IdentityData, Asi.Contracts';
    /**
     * Gets or sets the name of the entity type.
     */
    EntityTypeName?: string;
    /**
     * To the identifier.
     */
    id?: any;
    /**
     * Gets or sets the identity elements.
     */
  IdentityElements?: IdentityElements = new IdentityElements();
    /**
     * Gets the key.
     */
    key?: string;
}


export class IdentityElements {
  $type = "System.Collections.ObjectModel.Collection`1[[System.String, mscorlib]], mscorlib";
  $values = new Array<string>();
}
